import { MAX_PASSWORD_INPUT_VALIDATION } from "@/constants/common";
import { INVALID_PASSWORD_CONFIRM } from "@/constants/invalids";
import { validator } from "@/utils/validator";

export const resetPasswordSchema = validator.object().shape({
  email: validator.string().emptyToNull(),
  newPassword: validator.string().emptyToNull().strongPassword().max(MAX_PASSWORD_INPUT_VALIDATION).label("新しいパスワード").required(),
  confirmNewPassword: validator
    .string()
    .emptyToNull()
    .trim()
    .strongPassword()
    .max(MAX_PASSWORD_INPUT_VALIDATION)
    .oneOf([validator.ref("newPassword")], INVALID_PASSWORD_CONFIRM)
    .label("新しいパスワード（確認用）")
    .required(),
});
